import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components/ui/table'
import { Badge } from '@/shared/components/ui/badge'
import type { ModuloEstadisticas } from '../types'

interface ModuloProgressTableProps {
  modulos: ModuloEstadisticas[]
}

export function ModuloProgressTable({ modulos }: ModuloProgressTableProps) {
  if (!modulos.length) {
    return <p className="text-sm text-muted-foreground text-center py-4">Sin datos de módulos</p>
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Módulo</TableHead>
          <TableHead className="text-right">Participantes</TableHead>
          <TableHead className="text-right">Avance</TableHead>
          <TableHead className="text-right">% Avance</TableHead>
          <TableHead className="text-right">Aprobados</TableHead>
          <TableHead className="text-right">% Aprobación</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {modulos.map((m) => (
          <TableRow key={m.numero}>
            <TableCell className="font-medium">Módulo {m.numero}</TableCell>
            <TableCell className="text-right">{m.total_intentos.toLocaleString()}</TableCell>
            <TableCell className="text-right">{m.con_avance.toLocaleString()}</TableCell>
            <TableCell className="text-right">
              <Badge
                variant="outline"
                className={
                  m.tasa_avance >= 70
                    ? 'text-green-700 border-green-300 bg-green-50'
                    : m.tasa_avance >= 40
                    ? 'text-yellow-700 border-yellow-300 bg-yellow-50'
                    : 'text-red-700 border-red-300 bg-red-50'
                }
              >
                {m.tasa_avance}%
              </Badge>
            </TableCell>
            <TableCell className="text-right">{m.aprobados.toLocaleString()}</TableCell>
            <TableCell className="text-right">
              <Badge
                variant="outline"
                className={
                  m.tasa_aprobacion >= 70
                    ? 'text-green-700 border-green-300 bg-green-50'
                    : m.tasa_aprobacion >= 40
                    ? 'text-yellow-700 border-yellow-300 bg-yellow-50'
                    : 'text-red-700 border-red-300 bg-red-50'
                }
              >
                {m.tasa_aprobacion}%
              </Badge>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
